import * as ACTION_TYPES from '../types';

let initialState = {
  merchantAndTransactionList: [],
  loading: false,
  error: false
}

export default (state = initialState, action) => {
    switch (action.type) {
      case ACTION_TYPES.GET_MERCTRANS:
        return { ...state, merchantAndTransactionList: action.data };
        
        case ACTION_TYPES.GET_MERCTRANSBYID:
          return { ...state, merchantAndTransactionList: action.data };
      default:
        return state;
    }
}